import { TopBar } from "@/components/layout";
import WebsitesTable from "@/components/WebsitesTable";

const DomainsPage = () => {
  return (
    <>
      <TopBar title="Domeny" />
      <div className="flex-1 overflow-auto p-6">
        <WebsitesTable />
      </div>
    </>
  );
};

export default DomainsPage;
